var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".8vw",
    height: ".7vw",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2316 2.0625H5.56914C4.52982 2.0625 3.53307 2.43783 2.79817 3.10593C2.06326 3.77403 1.65039 4.68017 1.65039 5.625V12.375C1.65039 12.8428 1.75175 13.3061 1.94869 13.7383C2.14562 14.1705 2.43428 14.5633 2.79817 14.8941C3.53307 15.5622 4.52982 15.9375 5.56914 15.9375H14.2316C15.2703 15.9355 16.2658 15.5595 17.0002 14.8919C17.7346 14.2242 18.1482 13.3192 18.1504 12.375V5.625C18.1482 4.68078 17.7346 3.77579 17.0002 3.10812C16.2658 2.44045 15.2703 2.06448 14.2316 2.0625ZM11.2204 8.3025C10.8145 8.51294 10.3553 8.62361 9.88801 8.62361C9.42075 8.62361 8.96154 8.51294 8.55564 8.3025L2.90439 5.355C2.97746 4.75898 3.28967 4.20836 3.7813 3.80847C4.27292 3.40859 4.90945 3.1875 5.56914 3.1875H14.2316C14.8908 3.18914 15.5264 3.4108 16.0176 3.81038C16.5089 4.20995 16.8216 4.75962 16.8964 5.355L11.2204 8.3025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.23f434c55c769e3cc950737eb3ba957a.svg";
export { ForwardRef as ReactComponent };